import { render, staticRenderFns } from "./shopify-order.vue?vue&type=template&id=a0cd9f5c&scoped=true&"
import script from "./shopify-order.vue?vue&type=script&lang=js&"
export * from "./shopify-order.vue?vue&type=script&lang=js&"
import style0 from "./shopify-order.vue?vue&type=style&index=0&id=a0cd9f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cd9f5c",
  null
  
)

export default component.exports